export const PUBLIC = "public";
export const PRIVATE = "private";
export const DUAL = "dual";
